import JobModel from './JobModel';

export {
    JobModel
};



// WEBPACK FOOTER //
// ./plugins/jobs/web_client/models/index.js